import React from 'react'
import { Redirect } from 'react-router-dom'
import {IsAuthenticated} from '../utils/TokenHandler'

function PrivateRoute(props) {
    if (IsAuthenticated())
        return (
            <>
                {props.children}
            </>
        )
    else
        return (
            <Redirect to="/loginbymobile" />
        )
}

export default PrivateRoute